import { render, staticRenderFns } from "./TicketsStock.vue?vue&type=template&id=6e08e15a&"
import script from "./TicketsStock.vue?vue&type=script&lang=js&"
export * from "./TicketsStock.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Ramon/PROYECTOS/JuanGabriel_POS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e08e15a')) {
      api.createRecord('6e08e15a', component.options)
    } else {
      api.reload('6e08e15a', component.options)
    }
    module.hot.accept("./TicketsStock.vue?vue&type=template&id=6e08e15a&", function () {
      api.rerender('6e08e15a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/TicketsStock.vue"
export default component.exports